/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ commune: NonNullable<unknown>, district: NonNullable<unknown>, ward: NonNullable<unknown>, current: NonNullable<unknown> }} Carrier_Legacy_Address_WardInputs */

const vi_carrier_legacy_address_ward = /** @type {(inputs: Carrier_Legacy_Address_WardInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Địa chỉ ghi ${i?.commune}, ${i?.district}: nay thuộc ${i?.ward}, không thuộc ${i?.current}.`)
};

/**

* @param {Carrier_Legacy_Address_WardInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const carrier_legacy_address_ward = /** @type {((inputs: Carrier_Legacy_Address_WardInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Carrier_Legacy_Address_WardInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_carrier_legacy_address_ward(inputs)
});